export const BikeAlertTypes = {
  outOfZone: { value: 'outOfZone', name: 'Poza strefą' },
  lowBattery: { value: 'lowBattery', name: 'Niski poziom baterii' },
  communicationDelay: { value: 'communicationDelay', name: 'Opóźnienie komunikacji' },
  serviceDue: { value: 'serviceDue', name: 'Zaległy serwis' },
};
